exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-c0905f28] .quill-editor .ql-editor{overflow:hidden;padding-top:0;padding-bottom:0;cursor:text}\n", ""]);

